import Axios from "axios";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  NativeSelect,
  TextField,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { useCookies } from "react-cookie";

import { ConvertStr2DatetimeLocal } from "../../common/timeParsing.js";

const datetimeFormat = "yyyy/MM/dd HH:mm:ss";

const BrandMicrosoftSn = 1;

const productDetailDefault = {
  sn: 0,
  productNo: "",
  hib2bProductCode: "",
  msProductNo: "",
  productSn: "",
  pid: "",
  description: "",
  simple: "",
  price: "",
  priceCost: "",
  priceSpecial: "",
  buyLimit: "",
  isUpVisible: false,
  markUpPrice: 0,
  markUpPriceActiveDate: ConvertStr2DatetimeLocal(format(new Date(), datetimeFormat)),
};

const productDetailFieldList = {
  ProductSn: "商品名稱",
  Description: "商品折扣",
  Simple: "產品簡介",
  Context: "產品描述",
  PriceSpecial: "優惠價",
  ProductStatusSn: "商品狀態",
  BuyLimit: "購買數量限制",
  Reviewed: "審核狀態",
  CreateDate: "建檔時間",
  MarkUpPrice: "漲價金額",
  MarkUpPriceActiveDate: "漲價金額生效時間",
};

function logTable(data) {
  const columns = [
    {
      title: "時間",
      field: "modifyTime",
      render: (rowData) => format(new Date(rowData.modifyTime), datetimeFormat),
    },
    { title: "帳號", field: "operatorName" },
    { title: "欄位", field: "field", lookup: productDetailFieldList },
    { title: "修改前資料", field: "beforeValue" },
    { title: "修改後資料", field: "afterValue" },
    { title: "狀態", field: "productStatusSn" },
    { title: "IP位址", field: "modifyIP" },
  ];
  return (
    <MaterialTable
      columns={columns}
      data={data}
      options={{
        search: false,
        paging: false,
        showTitle: false,
        toolbar: false,
        padding: "dense",
        sorting: false,
        rowStyle: (rowData) => ({
          backgroundColor: rowData.tableData.id % 2 ? "#FFFFFF" : "#EEEEEE",
        }),
      }}
    />
  );
}

// closeModal
export default function ProductDetailModalOfMicrosoft(props) {
  const [cookies] = useCookies(["session"]);
  const [modalStatus, setModalStatus] = useState(false);
  const [reviewed, setReviewed] = useState(false);
  const [productList, setProductList] = useState([]);
  const [productDetailSn, setProductDetailSn] = useState(0);
  const [productDetail, setProductDetail] = useState(productDetailDefault);
  const [modifyLog, setModifyLog] = useState([]);
  const [
    isInsertReviewLaunchProductDetail,
    setisInsertReviewLaunchProductDetail,
  ] = useState(false);
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  const closeModal = props.closeModal;

  useEffect(() => {
    if (props.openModal) {
      getListDataOfMicrosoft();
      setReviewed(props.review);
      getProductDetail(props.productDetailSn);
      setisInsertReviewLaunchProductDetail(
        props.isInsertReviewLaunchProductDetail
      );
      if (props.isInsertReviewLaunchProductDetail) {
        setDisableSaveBtn(true);
      }
    }
    setModalStatus(props.openModal);
  }, [
    props.review,
    props.openModal,
    props.productDetailSn,
    props.isInsertReviewLaunchProductDetail,
  ]);

  /* 用於抓 Microsoft 商品的清單 */
  const getListDataOfMicrosoft = () => {
    Axios.post("/api/product/list", {
      PerPage: 0,
      OrderBy: "name",
      BrandSn: BrandMicrosoftSn,
    })
      .then((res) => {
        // console.log("ProductList:", res.data.data);
        setProductList(res.data.data);
      })
      .catch((err) => {
        console.log("getAllListDataOfMicrosoft:" + err);
      });
  };

  const handleChange = (event) => {
    var { name, value, type } = event.target;
    if (type === "number") {
      value = value > 2147483647 ? 2147483647 : parseFloat(value);
      value = value < 0 ? 0 : parseFloat(value);
    } else if (type === "select-one") {
      value = parseInt(value);
    } else if (type === "datetime-local") {
      // convert local datetime to string with timezone
      try {
        value = new Date(value).toISOString();
      } catch (event) {
        value = "";
      }
    }

    setProductDetail((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const toggleIsUpVisible = () => {
    setProductDetail((prevState) => ({
      ...prevState,
      isUpVisible: !prevState.isUpVisible,
    }));
  };

  const getProductDetail = (sn) => {
    setProductDetailSn(sn);
    if (sn && sn !== 0) {
      const getProductDetail = Axios.post("/api/product/detail", { sn: sn });
      const getModifyLog = Axios.post("/api/product/detail/log/list", {
        sn: sn,
      });

      Axios.all([getProductDetail, getModifyLog])
        .then(
          Axios.spread((productDetailResponse, modifyLogResponse) => {
            console.table(productDetailResponse.data);
            setProductDetail(productDetailResponse.data);
            setModifyLog(modifyLogResponse.data ? modifyLogResponse.data : []);
          })
        )
        .catch(() => {
          alert("後端異常");
          setProductDetail(productDetailDefault);
          setModifyLog([]);
        });
    } else {
      setProductDetail(productDetailDefault);
      setModifyLog([]);
    }
  };

  const productDetailSubmit = (e) => {
    e.preventDefault();

    // 如果是新增商品立即要使用要使用新增且立即審閱上架
    const insertReviewLaunchUrl =
      "/api/product/detail/insertAndReviewAndLaunch";
    const insertOrUpdateUrl = "/api/product/detail/insertOrUpdate";
    if (window.confirm("確定儲存此筆資料？")) {
      Axios.post(
        isInsertReviewLaunchProductDetail
          ? insertReviewLaunchUrl
          : insertOrUpdateUrl,
        {
          productDetail: productDetail,
          OpName: cookies.op_name,
          ReviewedAndOnline: false
        }
      )
        .then((res) => {
          const { sn, productNo } = res.data;

          alert("儲存成功");
          // closeModal({ ...productDetail, sn: sn, no: no });
          closeModal({ ...productDetail, sn: sn, no: productNo });
          // window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          alert("後端異常");
        });
    }
  };

  const productDetailSubmitReviewAndOnline = () => {

    // 如果是新增商品立即要使用要使用新增且立即審閱上架
    const insertReviewLaunchUrl =
      "/api/product/detail/insertAndReviewAndLaunch";
    const insertOrUpdateUrl = "/api/product/detail/insertOrUpdate";
    if (window.confirm("確定儲存此筆資料？")) {
      Axios.post(
        isInsertReviewLaunchProductDetail
          ? insertReviewLaunchUrl
          : insertOrUpdateUrl,
        {
          productDetail: productDetail,
          OpName: cookies.op_name,
          ReviewedAndOnline: true
        },
      )
        .then((res) => {
          const { sn, productNo } = res.data;

          alert("儲存成功");
          // closeModal({ ...productDetail, sn: sn, no: no });
          closeModal({ ...productDetail, sn: sn, no: productNo });
          // window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          alert("後端異常");
        });
    }
  };

  const productReview = () => {
    if (window.confirm("確定審核此筆資料？")) {
      Axios.post("/api/product/detail/review", {
        sn: productDetail.sn,
        OpName: cookies.op_name,
      })
        .then((res) => {
          alert("審核完成");
          closeModal();
          // window.location.reload(true);
        })
        .catch((error) => {
          console.log(error);
          alert("後端異常");
        });
    }
  };

  const productNameChange = (event) => {
    if (event.target.value !== "") {
      const { otherProductItemFilter } = props;

      var sn = parseInt(event.target.value);
      // console.log(sn);
      // console.log(sn !== null);
      var product = productList.find((product) => {
        if (product.sn === sn) return product;
        return null;
      });

      if (isInsertReviewLaunchProductDetail) {
        const isDisable =
          otherProductItemFilter({
            ...product,
            charge_type_sn: product.chargeTypeSn,
          }) === false;
        setDisableSaveBtn(isDisable);

        if (isDisable) {
          alert("請選擇「年繳」商品和相同「產品碼」");
        }
      }

      setProductDetail((prevState) => ({
        ...prevState,
        productSn: product.sn,
        pid: product.pid,
        price: product.price,
        priceCost: product.priceCost,
        chargeTypeSn: product.chargeTypeSn,
        name: product.name,
        plan: product.plan,
      }));
    } else {
      setProductDetail((prevState) => ({
        ...prevState,
        productSn: 0,
        pid: "",
        price: "",
        priceCost: "",
      }));
    }
  };

  return (
    <Dialog
      open={modalStatus}
      onClose={closeModal}
      maxWidth="md"
      scroll="paper"
    >
      <Box>
        <form onSubmit={productDetailSubmit}>
          <DialogTitle>商品重要資訊設定：</DialogTitle>
          <DialogContent dividers>
            <TextField
              fullWidth
              margin="dense"
              label="商品編號（系統自動產生）"
              name="productNo"
              value={productDetail.productNo}
              disabled
              required
              onChange={handleChange}
            />
            {/* <TextField
              fullWidth
              autoFocus
              margin="dense"
              label="HiB2B商品編號"
              name="hib2bProductCode"
              value={productDetail.hib2bProductCode}
              disabled={reviewed}
              onChange={handleChange}
            /> */}
            <FormControl fullWidth>
              <InputLabel htmlFor="demo-customized-select-native">
                商品名稱
                (如需修改商品名稱、方案、定價、成本及PID，請至商品種類修改，謝謝！)
              </InputLabel>
              <NativeSelect
                value={productDetail.productSn}
                disabled={reviewed}
                onChange={productNameChange}
                required
              >
                <option></option>
                {productList.map((product, index) => {
                  return (
                    <option
                      key={index}
                      value={product.sn}
                      disabled={
                        !product.reviewed || product.msNCEOfferId === ""
                      }
                    >
                      {product.name}
                      {product.plan !== "" ? " - " + product.plan : ""}
                    </option>
                  );
                })}
              </NativeSelect>
            </FormControl>
            <TextField
              fullWidth
              margin="dense"
              label="小額付款編號(PID)"
              name="pid"
              value={productDetail.pid}
              disabled
            />
            <TextField
              fullWidth
              margin="dense"
              label="定價"
              value={productDetail.price}
              disabled
            />
            <TextField
              fullWidth
              margin="dense"
              label="成本"
              value={productDetail.priceCost}
              disabled
            />
            <TextField
              fullWidth
              margin="dense"
              label="優惠價"
              name="priceSpecial"
              type="number"
              helperText={
                productDetail.isUpVisible
                  ? "與官網的優惠價連動，請小心更改"
                  : ""
              }
              error={productDetail.isUpVisible}
              value={productDetail.priceSpecial}
              onChange={handleChange}
              autoComplete="off"
              disabled={reviewed}
              required
            />
            <TextField
              fullWidth
              margin="dense"
              label="銷售限額"
              name="buyLimit"
              type="number"
              value={productDetail.buyLimit}
              onChange={handleChange}
              autoComplete="off"
              disabled={reviewed}
              required
            />
            <TextField
              fullWidth
              margin="dense"
              label="商品折扣"
              name="description"
              value={productDetail.description}
              disabled={reviewed}
              autoComplete="off"
              onChange={handleChange}
            />
            <TextField
              fullWidth
              margin="dense"
              label="商品簡介"
              name="simple"
              autoComplete="off"
              multiline
              value={productDetail.simple}
              disabled={reviewed}
              onChange={handleChange}
            />
            <TextField
              fullWidth
              margin="dense"
              label="漲價金額"
              name="markUpPrice"
              autoComplete="off"
              type="number"
              value={productDetail.markUpPrice}
              disabled={reviewed}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              fullWidth
              margin="dense"
              label="漲價金額生效時間"
              type="datetime-local"
              helperText={"空白為不更動價位"}
              name={"markUpPriceActiveDate"}
              value={productDetail.markUpPrice === 0 ? ConvertStr2DatetimeLocal(format(new Date(), datetimeFormat)) : ConvertStr2DatetimeLocal(productDetail.markUpPriceActiveDate)}
              disabled={reviewed}
              onChange={handleChange}
              inputProps={{ step: 1 }} // for datetime to show second
              InputLabelProps={{ shrink: true }}
            />
            {/* <TextField fullWidth margin="dense" label="後台受理建單設定" /> */}
            <Button
              onClick={toggleIsUpVisible}
              color="primary"
              style={{
                fontSize: '16px', // 調整字體大小
                fontWeight: 'bold', // 設置字體為粗體
                color: productDetail.isUpVisible ? 'green' : 'red', // 根據狀態設置顏色
              }}
            >
              {productDetail.isUpVisible ? "取消顯示於官網" : "顯示於官網"}
            </Button>
          </DialogContent>
          <DialogActions>
            <Typography hidden={!reviewed}>
              <Button onClick={productReview} name="review" color="primary">
                審核
              </Button>
            </Typography>
            <Typography hidden={reviewed}>
              <Button onClick={productDetailSubmitReviewAndOnline} name="saveAndReviewAndOnline" color="primary">
                儲存後審核並上架
              </Button>
            </Typography>
            <Typography hidden={reviewed}>
              <Button
                type="submit"
                name="save"
                color="primary"
                disabled={disableSaveBtn}
              >
                儲存
              </Button>
            </Typography>
            <Button onClick={closeModal} color="primary">
              取消
            </Button>
          </DialogActions>
          <Typography component="div" hidden={productDetailSn === 0}>
            <DialogTitle>商品更改紀錄：</DialogTitle>
            <DialogContent dividers>{logTable(modifyLog)}</DialogContent>
          </Typography>
        </form>
      </Box>
    </Dialog>
  );
}
